module.exports = "<button mat-button color=\"primary\" \n        (click)=\"clearThrottling$$()\"\n        [disabled]=\"loading\">Clear</button>\n"